export const eventTypeFilterOptions = ['All', 'Race', 'Match'];

export const currencyFilterOptions = ['All', 'BC CASH', 'GEMS'];
